const RemovePrefix = (dateStr) => {
    // Use regex to remove the prefix (T5 or CN) from the start of the string
    return dateStr.replace(/^(T[0-9]+|CN)[-/]?/, '');
    
  };

export default RemovePrefix